<template>
  <div>
    <van-cell title="课程" title-class="abc" required is-link @click="selectKc">
      <template>
        <div v-if="courseStudentParams.curriculumId" style="color: var(--g8)">
          {{ courseStudentParams.curriculumName }}
        </div>
        <div v-else style="color: var(--g5)">请选择</div>
      </template>
    </van-cell>
    <van-cell
      title="学员"
      is-link
      required
      @click="selectStudent"
      v-if="this.formPage !== 'reserve'"
    >
      <template>
        <div v-if="courseStudentParams.studentIds.length > 0" style="color: var(--g8)">
          <div class="van-ellipsis" style="color: var(--g8)">
            <span v-if="courseStudentParams.studentIds.length > 1"> 已选{{ courseStudentParams.studentIds.length }}个学员 </span>
            <span v-else>
              {{ courseStudentParams.studentObjs[0] && courseStudentParams.studentObjs[0].name }}
            </span>
          </div>
          <span v-if="courseStudentParams.studentIds.length > 0" style="color: var(--tlc);" @click.stop="showStuDetail">
            查看学员课时
          </span>
        </div>
        <div v-else style="color: var(--g5)">请选择(可多选)</div>
      </template>
    </van-cell>

    <!-- 查看已选名单 -->
    <van-action-sheet v-model="as1" :round="false" get-container="body">
      <div class="as1wrap">
        <div class="head">
          <div class="til" v-if="courseStudentParams.studentObjs.length > 1">
            已选学员({{ courseStudentParams.studentObjs.length }})
          </div>
          <div class="til" v-else-if="courseStudentParams.studentObjs.length === 1">
            {{ courseStudentParams.studentObjs[0].name }}
          </div>
          <div class="clearbtn" @click="delAllStu">清空</div>
        </div>
        <div class="linewrap" v-if="courseStudentParams.studentObjs.length > 0">
          <div
            class="line van-hairline--bottom"
            v-for="(stu, index) in courseStudentParams.studentObjs"
            :key="stu.id"
          >
            <div class="left-container">
              <van-icon
                class="delete-relation"
                class-prefix="vxs-icon"
                name="system_del"
                size="16"
                color="var(--c3)"
                @click.stop="delStu(index)"
              />
            </div>
            <div class="right-container" v-if="classHoursMap[stu.id] && classHoursMap[stu.id].courseCard">
              <div class="name">{{ stu.name }}</div>
              <div class="student-amount-item">
                <div class="amount">
                  <span class="label">剩余：</span>
                  <span
                    :class="{ owe: classHoursMap[stu.id].courseCard.classHourRemainTotalAmount <= 0 }">{{ classHoursMap[stu.id].courseCard.classHourRemainTotalAmount >= 0 ? classHoursMap[stu.id].courseCard.classHourRemainTotalAmount : 0 }}<template 
                    v-if="classHoursMap[stu.id].courseCard.classHourRemainTotalAmount < 0">(欠费{{ Math.abs(classHoursMap[stu.id].courseCard.classHourRemainTotalAmount) }})</template>{{ lessonUnit }}
                  </span>
                  <span 
                    :class="{ owe: classHoursMap[stu.id].courseCard.dayRemainTotalAmount <= 0 }"
                    v-if="classHoursMap[stu.id].courseCard.dayRemainTotalAmount !== 0">，{{ classHoursMap[stu.id].courseCard.dayRemainTotalAmount >= 0 ? classHoursMap[stu.id].courseCard.dayRemainTotalAmount : 0 }}<template
                    v-if="classHoursMap[stu.id].courseCard.dayRemainTotalAmount < 0">(欠费{{ Math.abs(classHoursMap[stu.id].courseCard.dayRemainTotalAmount) }})</template>天
                  </span>
                </div>
                <div>已排课：{{ classHoursMap[stu.id].courseArrangeStat.count }}；已点名：{{ classHoursMap[stu.id].courseArrangeStat.signCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
let defaultParams = {
  curriculumId: '',
  curriculumName: '',
  studentIds: [],
  studentObjs: [],
}

export default {
  name: 'paike-course-first',
  props: {
    params: {},
    formPage: '',
    campusList: Array,
  },
  data(){
    return {
      courseStudentParams: {
        ...JSON.parse(JSON.stringify(defaultParams)),
      },
      // 查看已选名单
      as1: false,
      classHoursMap: {},
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    // 选择课程
    async selectKc() {
      let res = await app.x3.side.xsCourse({
        id: this.courseStudentParams.curriculumId,
        params: {
          campusIds: [this.params.campusId],
          chargeType: 0,
        },
        filter: {
          enableCampusFilter: false,
        },
        config: {
          radio: true,
          must: true,
        },
      });
      // 课程发生变化，需要清空学员信息
      this.courseStudentParams.studentIds.splice(0);
      this.courseStudentParams.studentObjs.splice(0);
      this.updatePriceItemInfos(res);
    },
    //选择学员
    async selectStudent() {
      if (!this.courseStudentParams.curriculumId) {
        return vant.Toast('请先选择课程');
      }
      let args = {
        ids: this.courseStudentParams.studentIds,
        list: this.courseStudentParams.studentObjs,
        params: {
          campusIds: [this.params.campusId],
          campusList: this.campusList,
          status: [1],
          courseRelations: [1],
        },
        defaultParams: {
          status: [1],
        },
        config: {
          // 是否开启筛选能力
          enableLeft: false,
          enableCampus: false,
          enableDate: false,
          enableSearch: true,
          searchIcon: false,
          enableFilter: true,
          enableStudentStatus: true,
          enableStudentStatusIds: [1, 6, 7],
          enableStudentCourseRelations: true,
        },
      };
      if (this.courseStudentParams.curriculumId) {
        args.api = this.$api.findStudentsByCurriculumId;
        args.params.curriculumId = this.courseStudentParams.curriculumId;
      }
      let ret = await app.x3.side.xsStudent(args);
      this.courseStudentParams.studentIds = ret.ids;
      this.courseStudentParams.studentObjs = ret.list;

      // 获取课程剩余数量
      this.showLoading();
      const res = await this.$api.findStudentCurriculumCard({
        campusId: this.params.campusId,
        curriculumId: this.courseStudentParams.curriculumId,
        studentIds: this.courseStudentParams.studentIds,
      });
      vant.Toast.clear();
      const obj = {};
      res.data.forEach(item => {
        obj[item.studentId] = item;
      });
      this.classHoursMap = obj;
    },
    updatePriceItemInfos(res) {
      this.courseStudentParams.curriculumId = res ? res.id : '';
      this.courseStudentParams.curriculumName = res ? res.curriculumName : '';
    },
    resetCourseStudentInfos() { // 重置课程学员信息
      this.courseStudentParams = {
        ...JSON.parse(JSON.stringify(defaultParams)),
      };
    },
    // 查看已选名单
    async showStuDetail() {
      this.as1 = true;
    },
    // 清空已选的全部学员
    delAllStu() {
      this.as1 = false;
      this.courseStudentParams.studentObjs = [];
      this.courseStudentParams.studentIds = [];
    },
    // 移除某个已选学员
    delStu(index) {
      this.courseStudentParams.studentObjs.splice(index, 1);
      this.courseStudentParams.studentIds.splice(index, 1);
      if (this.courseStudentParams.studentIds.length == 0) {
        this.as1 = false;
      }
    },
  },
  watch: {
    courseStudentParams: {
      deep: true,
      immediate: true,
      handler: function (nv, ov) {
        this.$emit('change', this.courseStudentParams);
      },
    },
  }
}
</script>
<style lang="scss" scoped>
.as1wrap {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      left: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .linewrap {
    padding: 0 calc(var(--gap) * 16);
    .line {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) 0;
      .left-container {
        display: flex;
        align-items: center;
        // width: 50%;
      }
      .right-container {
        padding-left: calc(var(--gap) * 8);
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .student-amount-item {
        padding: calc(var(--gap) * 4) 0;
        text-align: right;
        color: var(--g7);
        .name {
          font-size: var(--fs-md);
          line-height: var(--lh-md);

          .tag {
            margin-right: calc(var(--gap) * 4);
            display: inline-block;
            font-weight: normal;
            padding: 0 calc(var(--gap) * 2);
            color: var(--white);
            background: var(--c1);
            border-radius: 2px;
            &.card {
              background-color: var(--c4);
            }
          }
        }
        .amount {
          margin-bottom: calc(var(--gap) * 4);
          flex-shrink: 0;
          // .label {
          //   color: var(--g6);
          // }
          .owe {
            color: var(--c3) !important;
          }
        }
      }

      .name {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g8);
        margin-right: 4px;
      }
    }
  }
}
</style>